export default "__VITE_ASSET__CbgmDvjZ__"